export default function WhyTherapistSection() {
  return (
    <section id="why-improve" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            なぜ改善できるのか
          </h2>
          <div className="flex items-center justify-center gap-4 mt-6">
            <div className="w-16 h-0.5 bg-[#10B981]"></div>
            <span className="text-sm text-[#666666] tracking-wider">Why We Can Help</span>
            <div className="w-16 h-0.5 bg-[#10B981]"></div>
          </div>
        </div>

        <div className="space-y-8">
          <div className="bg-[#F0FDF4] rounded-3xl p-10">
            <p className="text-base text-[#333333] leading-relaxed" style={{ lineHeight: '2.0' }}>
              長年の痛みに悩まれている方の多くは、<br />
              病院やリハビリ、整体に通っても、なかなか改善しないという経験をされています。
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 border-2 border-[#ECFDF5]">
            <p className="text-base text-[#333333] leading-relaxed" style={{ lineHeight: '2.0' }}>
              それは、痛みのある部分だけを見ていて、<br />
              本当の原因にアプローチできていないからかもしれません。
            </p>
          </div>

          <div className="bg-[#F0FDF4] rounded-3xl p-10">
            <p className="text-base text-[#333333] leading-relaxed mb-6" style={{ lineHeight: '2.0' }}>
              アスロン整体では、
            </p>
            <div className="bg-white rounded-2xl p-8 border-l-4 border-[#10B981]">
              <p className="text-xl font-bold text-[#065F46] text-center" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                「痛みの原因を見極め、全身を整える」
              </p>
            </div>
            <p className="text-base text-[#333333] leading-relaxed mt-6" style={{ lineHeight: '2.0' }}>
              というアプローチを大切にしています。
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 border-2 border-[#ECFDF5]">
            <p className="text-base text-[#333333] leading-relaxed" style={{ lineHeight: '2.0' }}>
              痛みには必ず原因があり、その原因は痛みのある場所とは別のところにあることもありうると考えています。
            </p>
          </div>

          <div className="bg-[#10B981] rounded-3xl p-10">
            <p className="text-lg text-white leading-relaxed mb-6" style={{ lineHeight: '2.0' }}>
              そこで私は、
            </p>
            <div className="space-y-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6">
                <p className="text-xl font-bold text-white" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  理学療法士としての専門知識
                </p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6">
                <p className="text-xl font-bold text-white" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  整体の技術と身体理論
                </p>
              </div>
            </div>
            <p className="text-lg text-white leading-relaxed mt-6" style={{ lineHeight: '2.0' }}>
              この2つを融合させることで、痛みの根本原因にアプローチしています。
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 border-2 border-[#ECFDF5]">
            <p className="text-base text-[#333333] leading-relaxed" style={{ lineHeight: '2.0' }}>
              身体は一部分だけではなく、全身がつながっています。<br />
              だからこそ、痛みのある場所だけでなく、全身の使い方を見ていくことが大切なのです。
            </p>
          </div>

          <div className="bg-gradient-to-br from-[#ECFDF5] to-[#F0FDF4] rounded-3xl p-10">
            <div className="space-y-4 mb-6">
              <div className="flex items-center gap-4">
                <div className="w-3 h-3 bg-[#10B981] rounded-full"></div>
                <p className="text-lg font-bold text-[#065F46]">痛みの原因をしっかり見極める</p>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-3 h-3 bg-[#10B981] rounded-full"></div>
                <p className="text-lg font-bold text-[#065F46]">関節センサーを正常化</p>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-3 h-3 bg-[#10B981] rounded-full"></div>
                <p className="text-lg font-bold text-[#065F46]">血流と姿勢を改善する</p>
              </div>
            </div>
            <p className="text-base text-[#333333] leading-relaxed" style={{ lineHeight: '2.0' }}>
              この3つのアプローチで、一時的な対処ではなく、根本からの改善を目指します。
            </p>
          </div>

          <div className="bg-[#10B981] rounded-3xl p-12 text-center">
            <p className="text-2xl md:text-3xl font-bold text-white mb-6" style={{ fontFamily: "'Noto Serif JP', serif", lineHeight: '1.8' }}>
              だから、長年の痛みでも<br className="md:hidden" />改善できるのです。
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 border-2 border-[#10B981]">
            <p className="text-base text-[#333333] leading-relaxed text-center" style={{ lineHeight: '2.0' }}>
              あなたの身体が本来持っている力を引き出し、<br className="hidden md:block" />
              痛みのない、ラクに動ける毎日を取り戻すお手伝いをさせてください。
            </p>
          </div>
        </div>

        <div className="text-center mt-12">
          <a
            href="https://lin.ee/uGMpYkR"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#06C755] text-white text-lg font-bold rounded-full hover:bg-[#05B04A] transition-all duration-300 shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-line-fill text-2xl"></i>
            <span>LINEで気軽に相談する</span>
          </a>
          <p className="text-sm text-[#666666] mt-4">
            お電話が難しい方は、公式LINEからもお気軽にご相談ください
          </p>
        </div>
      </div>
    </section>
  );
}